/*
 *  Copyright
 *
 *  Tegona S.A.
 *
 *  Tegona JS © 2017, Tegona S.A.
 *
 *  ALL RIGHTS RESERVED. THIS PROGRAM CONTAINS MATERIAL PROTECTED
 *  UNDER INTERNATIONAL AND SWITZERLAND COPYRIGHT LAWS AND TREATIES.
 *  ANY UNAUTHORIZED USE OF THE PROGRAM, INCLUDING REPRODUCTION,
 *  MODIFICATION, TRANSFER, TRANSMITTAL OR REPUBLICATION OF THIS
 *  MATERIAL IN ANY FORM OR BY ANY MEANS IS PROHIBITED WITHOUT
 *  SPECIFIC WRITTEN PERMISSION OF THE COPYRIGHT HOLDER.
 *
 *  copyright@tegona.com
*/

import Request from 'generic/request/Request'

export const APPLICANTS_IDENTITY_LIST_URL = '/api/applicant/identity/list/'
export const CONSUMERS_IDENTITY_LIST_URL = '/api/consumer/identity/list/'

const IDENTITY_URL = '/api/identity/'
const IDENTITY_VALIDATION_URL = '/api/identity/validation/'

export const getIdentity = (uid) => {
  return Request.getRequest(IDENTITY_URL + (uid ? uid + '/' : ''))
    .then((result) => {
      const identity = result.data.object

      return {
        ...identity,
        emails: identity.emails ? identity.emails.split(',') : [],
        phone_numbers: identity.phone_numbers ? identity.phone_numbers.split(',') : [],
        fax_numbers: identity.fax_numbers ? identity.fax_numbers.split(',') : []
      }
    })
}

export function postIdentityValidation(data, uid) {
  data = {
    ...data,
    emails: Array.isArray(data.emails) ? undefined: data.emails,
    phone_numbers: Array.isArray(data.phone_numbers) ? undefined: data.phone_numbers,
    fax_numbers: Array.isArray(data.fax_numbers) ? undefined: data.fax_numbers,
  }

  return Request.postRequest(IDENTITY_VALIDATION_URL + (uid ? uid+ '/' : ''), data)
    .then((result) => {
      return result.data.object
    })
}

export const postIdentity = (identity) => {
  identity = {
    ...identity,
    emails: Array.isArray(identity.emails) ? undefined: identity.emails,
    phone_numbers: Array.isArray(identity.phone_numbers) ? undefined: identity.phone_numbers,
    fax_numbers: Array.isArray(identity.fax_numbers) ? undefined: identity.fax_numbers,
  }

  return Request.postRequest(IDENTITY_URL + (identity.uid ? identity.uid + '/' : ''), identity)
    .then((result) => {
      return result.data.object
    })
}



// WEBPACK FOOTER //
// ./src/actions/Identity.js